import { FC } from "react";

import classes from "./Vote.module.css";
import SectionHeader from "../Layout/SectionHeader";
import { getLang, i18n } from "../../i18n";

const VoteEmpty: FC = () => {
  const lang = getLang();
  const t = i18n.voteEmpty[lang];
  return (
    <>
      <SectionHeader label={t.title} back="/votes" black={true} />

      <section className={classes.voting}>
        <div className={classes.fullscreen}>
          <div className="container">
            <div className={classes.blocked} style={{ color: "black" }}>
              {t.messageLine1}
              <br />
              {t.messageLine2}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default VoteEmpty;
